import { ErrorCodes } from '../../../ErrorHandler/apiErrorHandler';
import { PIEZO_SIGNING_FAILED_MESSAGE } from '../../../client/piezo/provisioning/PiezoClient.constants';

/** The banner text for a failure, shared by the components' useEffect and refreshData's catch. */
export const deriveErrorMessage = (error: unknown, component: string): string => {
  const message = error instanceof Error ? error.message : String(error ?? '');
  if (message.includes(PIEZO_SIGNING_FAILED_MESSAGE)) {
    return PIEZO_SIGNING_FAILED_MESSAGE;
  }
  if (component === 'lse') {
    return 'Unable to get LSE details. Please refresh the page or try again later';
  }
  if (component === 'cloudwatchGraphs') {
    return 'Unable to get Cloudwatch Metrics. Please refresh or try again later';
  }

  if (component === 'domainList') {
    return `Unable to get the domain list. Failed with ${message.replace(/\.+$/, '')}. Please refresh the page or try again later.`;
  }
  // A truncated or non-JSON body reaches the client as a parse error, not as a status. The proxy timing
  // out mid-response is the usual cause, so it is reported as the gateway timeout it actually is.
  if (message.includes('unexpected character') || message.includes('Unexpected token')) {
    return (
      'Unable to get domain details. Failed with ' +
      ErrorCodes.BAD_GATEWAY +
      ' Timeout. Please reload the page or try again later'
    );
  }
  return 'Unable to get domain details. Failed with ' + message;
};
